import { useEffect, useRef } from 'react';

type Props = {
  seed: string;
  onClose: () => void;
  onRestart: () => void;
  onAbandon: () => void;
};

export function RunActionsModal({ seed, onClose, onRestart, onAbandon }: Props) {
  const closeRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    closeRef.current?.focus();
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="modal-backdrop" role="presentation">
      <section
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="run-actions-title"
      >
        <button ref={closeRef} className="modal-close" onClick={onClose} aria-label="Continue run">
          ×
        </button>
        <p className="eyebrow">Run controls</p>
        <h2 id="run-actions-title">Restart or abandon this run?</h2>
        <p>
          Seed <code>{seed}</code>. Restarting recreates this exact run; abandoning removes its
          saved progress.
        </p>
        <div className="button-row modal-actions">
          <button className="button button--secondary" onClick={onClose}>
            Continue run
          </button>
          <button className="button" onClick={onRestart}>
            Restart seed
          </button>
          <button className="button button--danger" onClick={onAbandon}>
            Abandon run
          </button>
        </div>
      </section>
    </div>
  );
}
